import {BrowserModule} from '@angular/platform-browser';
import {ErrorHandler, NgModule} from '@angular/core';
import {HttpClientModule} from '@angular/common/http';

import {AppRoutingModule} from './app-routing.module';
import {AppComponent} from './app.component';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {
    faAngleLeft,
    faAngleRight,
    faArrowDown,
    faArrowLeft,
    faArrowRight,
    faAsterisk,
    faBalanceScale,
    faBan,
    faBars,
    faCamera,
    faCaretDown,
    faCaretUp,
    faChartBar,
    faChevronRight,
    faCoffee,
    faCogs,
    faEdit,
    faEraser,
    faExclamationTriangle,
    faFile,
    faFilter,
    faMinus,
    faPencilAlt,
    faPlayCircle,
    faPlus,
    faSave,
    faSignInAlt,
    faSignOutAlt,
    faSpinner,
    faSquare,
    faStopCircle,
    faSync,
    faThLarge,
    faTimes,
    faTractor,
    faTrash,
    faUserCircle,
    faWifi,
    faSearch, faChevronLeft
} from '@fortawesome/pro-solid-svg-icons';
import {FaIconLibrary, FontAwesomeModule} from '@fortawesome/angular-fontawesome';
import {MoModule} from '../common';
import {FormsModule} from '@angular/forms';
import {SettingComponent} from './setting/setting.component';
import {DocComponent} from './doc/doc.component';
import {DataService} from './services/dataService';
import {MainComponent} from './main/main.component';
import {ScrollingModule} from '@angular/cdk/scrolling';
import {ComparisonComponent} from './comparison/comparison.component';
import {FilterComponent} from './filter/filter.component';
import {MoLemkenNoteComponent} from './component/mo-lemken-note/mo-lemken-note.component';
import {NgSelectModule} from '@ng-select/ng-select';
import {MoLemkenPercentageComponent} from './component/mo-lemken-percentage/mo-lemken-percentage.component';
import {MoLemkenInfoComponent} from './component/mo-lemken-info/mo-lemken-info.component';
import {LogErrorsHandler} from '../common/log/logErrorsHandler';
import { DataValidityMentionComponent } from './data-validity-mention/data-validity-mention.component';

@NgModule({
    declarations: [
        AppComponent,

        MainComponent,

        FilterComponent,
        ComparisonComponent,

        DocComponent,
        SettingComponent,
        MoLemkenNoteComponent,
        MoLemkenPercentageComponent,
        MoLemkenInfoComponent,
        DataValidityMentionComponent,
    ],
    imports     : [
        BrowserModule,
        AppRoutingModule,
        BrowserAnimationsModule,
        FormsModule,
        HttpClientModule,
        FontAwesomeModule,
        ScrollingModule,
        MoModule,
        NgSelectModule,
    ],
    providers   : [
        DataService,
        // AuthGuard
        {
            provide: ErrorHandler,
            useClass: LogErrorsHandler,
        }
    ],
    bootstrap   : [AppComponent]
})
export class AppModule {

    constructor(library: FaIconLibrary) {
        library.addIcons(
            faAngleLeft,
            faAngleRight,
            faArrowDown,
            faArrowLeft,
            faArrowRight,
            faAsterisk,
            faBalanceScale,
            faBan,
            faBars,
            faCamera,
            faCaretDown,
            faCaretUp,
            faChartBar,
            faChevronLeft,
            faChevronRight,
            faCoffee,
            faCogs,
            faEdit,
            faEraser,
            faExclamationTriangle,
            faFile,
            faFilter,
            faMinus,
            faPencilAlt,
            faPlayCircle,
            faPlus,
            faSave,
            faSignInAlt,
            faSignOutAlt,
            faSpinner,
            faSquare,
            faStopCircle,
            faSync,
            faThLarge,
            faTimes,
            faTractor,
            faTrash,
            faUserCircle,
            faWifi,
            faSearch
        );
    }
}
